import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "qr-input" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { slot: "end" }, "QR Code Scannen", -1)
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"scan-background\"></div><div class=\"container\"><div class=\"barcode-scanner--area--container\"><div class=\"relative\"><p>Richte die Kamera auf einen Barcode</p></div><div class=\"square surround-cover\"><div class=\"barcode-scanner--area--outer surround-cover\"><div class=\"barcode-scanner--area--inner\"></div></div></div></div></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isQrScanActive)
      ? (_openBlock(), _createBlock(_component_ion_button, {
          key: 0,
          color: "dark",
          expand: "block",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scanQrCode())),
          size: "large"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_icon, {
              slot: "end",
              icon: _ctx.icons.qrCodeOutline,
              style: {"margin-right":".25em"}
            }, null, 8, ["icon"]),
            _hoisted_2
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", null, [
      _hoisted_3,
      _createVNode(_component_ion_button, {
        color: "danger",
        expand: "full",
        fill: "outline",
        style: {"z-index":"99999"},
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancelScan()))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Scan beenden ")
        ]),
        _: 1
      })
    ], 512), [
      [_vShow, _ctx.isQrScanActive]
    ])
  ]))
}